/* global axios */
import ApiClient from './ApiClient';

// Visitas e feedback por imovel (ala do proprietario da Lia). O registro cruza
// pelo codigo do imovel, nunca pelo nome.
class PropertyVisitsAPI extends ApiClient {
  constructor() {
    super('property_visits', { accountScoped: true });
  }

  registrar(payload) {
    return axios.post(this.url, payload);
  }
}

export default new PropertyVisitsAPI();
